export default __webpack_public_path__ + "static/media/413af1a3-8b25-474c-9bb6-8d89bb907596.f4cb2692.ttf";